const enum Pages {
  ROOT = '/',
  MY_COMPANY = '/my-company',
  CONTRACTS = '/contracts',
  DOCUMENTS_AND_ACTS = '/documents-and-acts',
  REPRESENTATIVES = '/representatives',
  AUTH_CALLBACK = '/callback',
  NOT_AUTHORIZED = '/not-authorized',
  COMMERCIAL_METERING_POINTS = 'commercial-metering-points',
  EXPIRED_DEVICES = 'expired-devices',
}

export default Pages;
